export async function wait(duration, rejectPromise = false) {
    return new Promise((resolve, reject) => {
        setTimeout(() => (rejectPromise ? reject() : resolve()), duration);
    });
}
